import { render, staticRenderFns } from "./importorder.vue?vue&type=template&id=3949c306&scoped=true"
import script from "./importorder.vue?vue&type=script&lang=ts"
export * from "./importorder.vue?vue&type=script&lang=ts"
import style0 from "./importorder.vue?vue&type=style&index=0&id=3949c306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949c306",
  null
  
)

export default component.exports